import { selectCompletedOrderId } from 'reducers/root';
import { openNoFeedbackAnswersAlert } from 'actions/UI';
import fetchHelper from 'utils/fetchHelper';

import {
  REQUEST_FEEDBACK_QUESTIONS,
  REQUEST_FEEDBACK_QUESTIONS_SUCCESS,
  REQUEST_FEEDBACK_QUESTIONS_FAILURE,
  REQUEST_FEEDBACK_SUBMISSION_STATUS,
  REQUEST_FEEDBACK_SUBMISSION_STATUS_SUCCESS,
  REQUEST_FEEDBACK_SUBMISSION_STATUS_FAILURE,
  SUBMIT_FEEDBACK_ANSWERS,
  FEEDBACK_SUBMISSION_FAILURE,
  FEEDBACK_SUBMISSION_SUCCESS,
} from './constants';

function requestQuestions() {
  return {
    type: REQUEST_FEEDBACK_QUESTIONS,
  };
}

function requestQuestionsSuccess(questions) {
  return {
    type: REQUEST_FEEDBACK_QUESTIONS_SUCCESS,
    questions,
  };
}

function requestQuestionsFailure() {
  return {
    type: REQUEST_FEEDBACK_QUESTIONS_FAILURE,
  };
}

export const fetchQuestions = serviceId => dispatch => {
  dispatch(requestQuestions());

  const success = questions =>
    !questions.length ? dispatch(requestQuestionsFailure()) : dispatch(requestQuestionsSuccess(questions));

  const failure = () => {
    dispatch(requestQuestionsFailure());
  };

  fetchHelper(`/api/feedback/${serviceId}/questions`, 'GET', null, success, failure);
};

export const fetchSubmissionStatus = () => (dispatch, getState) => {
  const orderId = selectCompletedOrderId(getState());
  const url = orderId
    ? `/api/feedback/answers/submitted?order_id=${orderId}`
    : '/api/feedback/answers/submitted';

  dispatch({ type: REQUEST_FEEDBACK_SUBMISSION_STATUS });

  const success = response => {
    dispatch({
      type: REQUEST_FEEDBACK_SUBMISSION_STATUS_SUCCESS,
      submitted: !!(response && response.submitted),
    });
  };
  const failure = () => {
    dispatch({ type: REQUEST_FEEDBACK_SUBMISSION_STATUS_FAILURE });
  };

  fetchHelper(url, 'GET', null, success, failure);
};

const hasAnswer = value =>
  Array.isArray(value) ? value.length > 0 : value !== '' && value !== null && value !== undefined;

export const submitAnswers = answers => (dispatch, getState) => {
  if (!Object.values(answers).some(hasAnswer)) {
    dispatch(openNoFeedbackAnswersAlert());
    return;
  }

  const orderId = selectCompletedOrderId(getState());
  const payload = { ...answers, order_id: orderId };

  dispatch({
    type: SUBMIT_FEEDBACK_ANSWERS,
    answers: payload,
  });

  const success = () => {
    dispatch({ type: FEEDBACK_SUBMISSION_SUCCESS });
  };
  const fail = () => {
    dispatch({
      type: FEEDBACK_SUBMISSION_FAILURE,
      success: false,
      violations: null,
    });
  };
  fetchHelper('/api/feedback/answers', 'POST', payload, success, fail);
};
